var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto w-full max-w-sm sm:max-w-md md:max-w-lg lg:max-w-xl xl:max-w-2xl ..."},[_c('vx-card',{attrs:{"title":"Error Items"}},[_c('p',[_vm._v(_vm._s(_vm.errdata))]),_c('br')])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }